export default __webpack_public_path__ + "static/media/churches-schools-and-sports.769fa72f.jpg";